import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from '../../setting/setting.service';

@Component({
  selector: 'app-download',
  templateUrl: 'download.component.html',
})
export class DownloadComponent implements OnInit {
  constructor(
    public settingService: SettingService,
    public route: ActivatedRoute,
  ) {}

  urls: any = {};
  msg = '';

  async ngOnInit() {
    this.route.params.subscribe(params => {
      if (params) {
        switch (params.msg) {
          case 'login':
            this.msg = 'Please continue to the LC+ app to log in.';
            break;

          case 'gotoapp':
            this.msg = 'Password set! Please continue to the LC+ app to log in.';
            break;
        }
      }
    });
    this.urls = await this.settingService.mobileUrls();
    this.detectOsAndRedirect();
  }

  detectOsAndRedirect() {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      window.location.href = this.urls.android;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      window.location.href = this.urls.ios;
    }
  }
}
